import { render, staticRenderFns } from "./UserCouponStatDrawer.vue?vue&type=template&id=88aefab4&scoped=true"
import script from "./UserCouponStatDrawer.vue?vue&type=script&lang=js"
export * from "./UserCouponStatDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserCouponStatDrawer.vue?vue&type=style&index=0&id=88aefab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aefab4",
  null
  
)

export default component.exports